import script from "./MST36_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST36_001INS.vue?vue&type=script&setup=true&lang=js"

import "./MST36_001INS.vue?vue&type=style&index=0&id=1031cb47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1031cb47"]])

export default __exports__